import type { Transport } from '../../transport/Transport';

export interface ActivityEvent {
  readonly event_id: string;
  readonly event: string;
  readonly page?: string;
  readonly product_id?: number;
  readonly collection_id?: number;
  readonly details?: Record<string, string | number>;
}

export interface ActivityService {
  send(events: readonly ActivityEvent[], keepalive?: boolean): Promise<void>;
}

export function createLaravelActivityService(transport: Transport): ActivityService {
  return {
    async send(events, keepalive = true) {
      await transport.request({ method: 'POST', path: 'storefront/activity', body: { events }, keepalive });
    },
  };
}
